import React from "react";
import { motion } from "framer-motion";

const Appointment = () => {
    // Animation Variants
    const fadeIn = {
        hidden: { opacity: 0, y: 50 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
    };

    const slideInLeft = {
        hidden: { opacity: 0, x: -100 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } },
    };

    const slideInRight = {
        hidden: { opacity: 0, x: 100 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } },
    };

    return (
        <>
            {/* Hero Section */}
            <motion.div
                className="h-screen bg-secondary flex flex-col md:flex-row w-full p-8 md:p-24 gap-8"
                initial="hidden"
                animate="visible"
                variants={fadeIn}
            >
                <motion.div
                    className="flex flex-col justify-center items-start gap-4 md:gap-6"
                    variants={slideInLeft}
                >
                    <h2 className="text-2xl md:text-3xl font-normal font-nunito-sans text-primary">
                        We're Here to Help
                    </h2>
                    <h1 className="text-4xl md:text-6xl font-black font-playfair-display text-primary">
                        Schedule Your Appointment Today!
                    </h1>
                    <p className="text-lg md:text-xl font-normal font-nunito-sans text-primary">
                        Let us assist you with your glass needs. Whether it's residential, commercial, or automotive, 
                        our team is ready to provide the best solutions tailored to your requirements.
                    </p>
                </motion.div>
                <motion.iframe
                    src="https://calendar.google.com/calendar/appointments/schedules/AcZssZ3Cg9xlx-vPB81f2a_kkRXUMi8NlaN2rP4sOZ0hnbqDkfbwWfd5ehp1C5Tit3jTIZHQ0WdJoPdh?gv=true"
                    className="h-full w-full bg-white rounded-md shadow-2xl"
                    title="Appointment Scheduler"
                    variants={slideInRight}
                ></motion.iframe>
            </motion.div>

           
        </>
    );
};

export default Appointment;